import isEqual from 'lodash/isEqual';
export class FovMutate {
    static get match() {
        return (nodeToMatch) => (node) => isEqual(nodeToMatch, node);
    }
    static get delete() {
        return (parent, node, index) => {
            parent.children.splice(index, 1);
        };
    }
}
//# sourceMappingURL=fov-mutate.js.map